import { Component } from 'react'
import * as styles from 'components/features/pfm/NetworthSummary/NetworthSummary.css'
import Section from 'components/features/pfm/NetworthSummarySection/NetworthSummarySection'

import NetworthAmountContainer from 'components/features/pfm/NetworthAmount/NetworthAmountContainer'
import NetworthRankContainer from 'components/features/pfm/NetworthRank/NetworthRankContainer'
import * as cn from 'classnames'
import NetworthDeltaContainer from 'components/features/pfm/NetworthDelta/NetworthDeltaContainer'
import withPerformanceMetrics from 'hocs/withPerformanceMetrics/withPerformanceMetrics'

class NetworthSummary extends Component {
  render () {
    return (
      <div className={ styles.sections }>
        { this.renderNetworth() }
        { this.renderDelta() }
        { this.renderRank() }
      </div>
    )
  }

  renderNetworth () {
    return (
      <div className={ styles.section }>
        <Section title='Your Net Worth'>
          <span className={ styles.netWorth }>
            <NetworthAmountContainer />
          </span>
        </Section>
      </div>
    )
  }

  renderDelta () {
    return (
      <div className={ cn(styles.section, styles.pointing) }>
        <NetworthDeltaContainer />
      </div>
    )
  }

  renderRank () {
    return (
      <div className={ cn(styles.section, styles.pointing) }>
        <NetworthRankContainer />
      </div>
    )
  }
}

const NetworthSummaryWithMetrics = withPerformanceMetrics(NetworthSummary, 'networth-summary')

export default NetworthSummaryWithMetrics
